/* BERK Cart Drawer – Kassen-Prüfung (Zustimmung, Wunschtermine) und Standzeit je Container
   - Zustimmung fehlt: zur Checkbox scrollen, verständliche Meldung statt Browser-Hinweis
   - Wunschtermin abgelaufen: Karte markieren, neuen Termin wählen lassen, Kasse bis dahin sperren
   - Standzeit-Verlängerung: Menge = Wochen je Container × Anzahl Container; verwaiste Verlängerungen entfernen
   Datumsregeln wie auf der Produktseite: Mo–Fr, ohne gesetzliche Feiertage NRW, Vorlauf in Werktagen (data-bc-lead). */
(function () {
  'use strict';
  if (window.__berkCartInit) return;
  window.__berkCartInit = true;

  var WD = ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'];
  var MAX_WEEKS = 4;

  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function key(d) { return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()); }
  function dmy(d) { return pad(d.getDate()) + '.' + pad(d.getMonth() + 1) + '.' + d.getFullYear(); }
  function addDays(d, n) { var x = new Date(d.getFullYear(), d.getMonth(), d.getDate()); x.setDate(x.getDate() + n); return x; }
  function today() { var t = new Date(); return new Date(t.getFullYear(), t.getMonth(), t.getDate()); }
  function parse(s) {
    var m = /^(\d{1,2})\.(\d{1,2})\.(\d{4})$/.exec(String(s || '').trim());
    return m ? new Date(+m[3], +m[2] - 1, +m[1]) : null;
  }
  function easter(y) {
    var a = y % 19, b = Math.floor(y / 100), c = y % 100, d = Math.floor(b / 4), e = b % 4,
      f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30,
      i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451),
      mo = Math.floor((h + l - 7 * m + 114) / 31), da = ((h + l - 7 * m + 114) % 31) + 1;
    return new Date(y, mo - 1, da);
  }
  var holidayCache = {};
  function holidays(y) {
    if (holidayCache[y]) return holidayCache[y];
    var e = easter(y), set = {};
    [new Date(y, 0, 1), addDays(e, -2), addDays(e, 1), new Date(y, 4, 1), addDays(e, 39), addDays(e, 50),
      addDays(e, 60), new Date(y, 9, 3), new Date(y, 10, 1), new Date(y, 11, 25), new Date(y, 11, 26), new Date(y, 11, 24), new Date(y, 11, 31)]
      .forEach(function (d) { set[key(d)] = true; });
    holidayCache[y] = set;
    return set;
  }
  function isDay(d) { var g = d.getDay(); return g !== 0 && g !== 6 && !holidays(d.getFullYear())[key(d)]; }
  function minDate(lead) {
    var d = today(), n = 0, guard = 0;
    while (n < lead) { d = addDays(d, 1); if (isDay(d)) n++; }
    while (!isDay(d) && guard++ < 30) d = addDays(d, 1);
    return d;
  }

  function drawer() { return document.querySelector('cart-drawer'); }
  function inner() { return document.querySelector('cart-drawer .berk-cd'); }
  function num(el, attr, def) { var v = parseInt(el.getAttribute(attr), 10); return isNaN(v) ? def : v; }
  /* Liquid liefert Properties als Liste von Paaren – in ein Objekt umwandeln */
  function props(el) {
    var v;
    try { v = JSON.parse(el.getAttribute('data-bc-props') || '{}'); } catch (e) { return {}; }
    if (Array.isArray(v)) { var o = {}; v.forEach(function (p) { if (p && p.length > 1) o[unent(p[0])] = unent(p[1]); }); return o; }
    if (v && typeof v === 'object') { var r = {}; Object.keys(v).forEach(function (k) { r[unent(k)] = unent(v[k]); }); return r; }
    return {};
  }
  /* Liquid maskiert Property-Werte (z. B. „Wurzeln &amp; Baumstubben“) – zurück in Klartext */
  var ENT = { amp: '&', quot: '"', '#39': "'", '#x27': "'", lt: '<', gt: '>' };
  function unent(s) {
    return typeof s === 'string' && s.indexOf('&') > -1 ? s.replace(/&(amp|quot|#39|#x27|lt|gt);/g, function (m, e) { return ENT[e]; }) : s;
  }

  /* ---------- Warenkorb ändern ---------- */
  var busy = false;
  function setBusy(on) { busy = on; var r = inner(); if (r) r.classList.toggle('is-busy', on); }
  function url(name, fallback) { return ((window.routes && window.routes[name]) || fallback) + '.js'; }
  function post(path, body) {
    return fetch(path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok || j.status) throw new Error(j.description || j.message || 'Fehler');
        return j;
      });
    });
  }
  function sectionIds() {
    var d = drawer();
    return d && typeof d.getSectionsToRender === 'function'
      ? d.getSectionsToRender().map(function (s) { return s.id; })
      : ['cart-drawer', 'cart-icon-bubble'];
  }
  function render(state) {
    var d = drawer();
    if (!d || !state || !state.sections) return;
    d.classList.toggle('is-empty', state.item_count === 0);
    /* Geschlossener Drawer (z. B. Korrektur beim Seitenaufruf): still aktualisieren statt ihn aufspringen zu lassen */
    if (!d.classList.contains('active') && typeof d.getSectionsToRender === 'function' && typeof d.getSectionInnerHTML === 'function') {
      d.getSectionsToRender().forEach(function (s) {
        var el = s.selector ? document.querySelector(s.selector) : document.getElementById(s.id);
        if (el && state.sections[s.id]) el.innerHTML = d.getSectionInnerHTML(state.sections[s.id], s.selector);
      });
      var ov = d.querySelector('#CartDrawer-Overlay');
      if (ov && typeof d.close === 'function') ov.addEventListener('click', d.close.bind(d));
      return;
    }
    if (typeof d.renderContents === 'function') d.renderContents(state);
  }
  function refresh() {
    return Promise.all([
      fetch(url('cart_url', '/cart')).then(function (r) { return r.json(); }),
      fetch(((window.routes && window.routes.root) || '/') + '?sections=' + sectionIds().join(',')).then(function (r) { return r.json(); })
    ]).then(function (res) { res[0].sections = res[1]; render(res[0]); }).catch(function () {});
  }
  function fail(msg) {
    var el = document.getElementById('CartDrawer-CartErrors');
    if (el) el.textContent = msg || 'Das hat nicht geklappt. Bitte versuchen Sie es erneut.';
  }
  function emit(list, state) {
    try {
      var E = window.StandardEvents && window.StandardEvents.CartLinesUpdateEvent;
      var host = document.querySelector('cart-drawer-items');
      if (!E || !host || !state) return;
      var def = E.createPromise();
      var removeAll = list.every(function (c) { return c.quantity === 0; });
      host.dispatchEvent(new E({
        action: removeAll ? 'remove' : 'update',
        context: 'cart',
        lines: list.map(function (c) { return { id: c.id, quantity: c.quantity }; }),
        promise: def.promise
      }));
      def.resolve({ cart: E.createCartFromAjaxResponse(state) });
    } catch (e) { /* Tracking-Ereignis optional */ }
  }
  /* Änderungen nacheinander senden, die letzte liefert den neu gerenderten Drawer */
  function changeLines(list) {
    if (!list.length || busy) return Promise.resolve();
    setBusy(true);
    var chain = Promise.resolve(), last = null;
    list.forEach(function (c, i) {
      chain = chain.then(function () {
        var body = { id: c.id, quantity: c.quantity };
        if (c.properties) body.properties = c.properties;
        if (i === list.length - 1) { body.sections = sectionIds(); body.sections_url = window.location.pathname; }
        return post(url('cart_change_url', '/cart/change'), body).then(function (j) { last = j; });
      });
    });
    return chain
      .then(function () { setBusy(false); render(last); emit(list, last); })
      .catch(function (e) { setBusy(false); fail(e && e.message); return refresh(); });
  }

  /* Mehrere Positionen in einem Schritt entfernen (Container + Verlängerung) */
  function removeKeys(keys) {
    if (!keys.length || busy) return Promise.resolve();
    setBusy(true);
    var updates = {};
    keys.forEach(function (k) { updates[k] = 0; });
    return post(url('cart_update_url', '/cart/update'), { updates: updates, sections: sectionIds(), sections_url: window.location.pathname })
      .then(function (j) { setBusy(false); render(j); emit(keys.map(function (k) { return { id: k, quantity: 0 }; }), j); })
      .catch(function (e) { setBusy(false); fail(e && e.message); return refresh(); });
  }

  /* ---------- Standzeit je Container ---------- */
  function datedKey(card) {
    var p = props(card), base = card.getAttribute('data-bc-ckey') || '';
    return p['Wunschtermin'] ? base + ' – Wunschtermin ' + p['Wunschtermin'] : base;
  }
  function planStandzeit(root) {
    var ops = [];
    root.querySelectorAll('.berk-cd-addon[data-bc-orphan]').forEach(function (a) {
      ops.push({ id: a.getAttribute('data-bc-key'), quantity: 0 });
    });
    root.querySelectorAll('.berk-cd-group').forEach(function (g) {
      var card = g.querySelector('.berk-cd-item');
      if (!card) return;
      var q = num(card, 'data-bc-qty', 0); g.querySelectorAll('.berk-cd-addon:not([data-bc-stz]):not([data-bc-orphan])').forEach(function (x) { if (props(x)['Express'] && num(x, 'data-bc-qty', 0) !== q) ops.push({ id: x.getAttribute('data-bc-key'), quantity: q }); });
      var adds = g.querySelectorAll('.berk-cd-addon[data-bc-stz]:not([data-bc-orphan])');
      if (!adds.length) return;
      if (adds.length === 1) {
        var a = adds[0], w = Math.max(1, num(a, 'data-bc-weeks', 1)), aq = num(a, 'data-bc-qty', 0);
        var p = props(a), upd = false, k = datedKey(card);
        if (String(p['Wochen je Container'] || '') !== String(w)) { p['Wochen je Container'] = String(w); upd = true; }
        if (k && p['Für Container'] !== k) { p['Für Container'] = k; upd = true; }
        if (aq !== w * q || upd) ops.push({ id: a.getAttribute('data-bc-key'), quantity: w * q, properties: upd ? p : undefined });
        return;
      }
      /* mehrere Verlängerungen für dieselbe Position: höchstens so viele Container wie bestellt */
      var left = q;
      adds.forEach(function (a) {
        var w = Math.max(1, num(a, 'data-bc-weeks', 1)), aq = num(a, 'data-bc-qty', 0);
        var keep = Math.max(0, Math.min(Math.floor(aq / w), left));
        left -= keep;
        if (keep * w !== aq) ops.push({ id: a.getAttribute('data-bc-key'), quantity: keep * w });
      });
    });
    return ops;
  }

  /* ---------- Wunschtermine ---------- */
  function hasExpress(card) { var g = card.closest('.berk-cd-group'), r = false; if (g) g.querySelectorAll('.berk-cd-addon:not([data-bc-orphan])').forEach(function (a) { if (props(a)['Express']) r = true; }); return r; } function checkDates(root) {
    var lead = num(root, 'data-bc-lead', 2), min = minDate(lead), bad = 0;
    root.querySelectorAll('.berk-cd-item[data-bc-date]').forEach(function (card) {
      var d = parse(card.getAttribute('data-bc-date'));
      var ok = !!d && d >= (hasExpress(card) ? minDate(1) : min) && isDay(d);
      card.classList.toggle('is-date-invalid', !ok);
      var fix = card.querySelector('.berk-cd-fix');
      if (!fix) return;
      fix.hidden = ok;
      if (ok) return;
      bad++;
      var sel = fix.querySelector('select');
      if (!sel || sel.getAttribute('data-ready')) return;
      sel.setAttribute('data-ready', '1');
      var html = '<option value="">Neuen Termin wählen …</option>', x = min, n = 0, guard = 0;
      while (n < 15 && guard++ < 60) {
        if (isDay(x)) { html += '<option value="' + dmy(x) + '">' + WD[x.getDay()] + ', ' + dmy(x) + '</option>'; n++; }
        x = addDays(x, 1);
      }
      sel.innerHTML = html;
      sel.addEventListener('change', function (e) {
        e.stopPropagation(); /* nicht an Dawns Mengenlogik weiterreichen */
        if (sel.value) changeDate(card, sel.value);
      });
    });
    return bad;
  }
  function changeDate(card, val) {
    var p = props(card);
    p['Wunschtermin'] = val;
    var ops = [{ id: card.getAttribute('data-bc-key'), quantity: Math.max(1, num(card, 'data-bc-qty', 1)), properties: p }];
    var base = card.getAttribute('data-bc-ckey') || '';
    var g = card.closest('.berk-cd-group');
    if (g) g.querySelectorAll('.berk-cd-addon[data-bc-stz]').forEach(function (a) {
      var ap = props(a);
      ap['Für Container'] = base + ' – Wunschtermin ' + val;
      if (!ap['Wochen je Container']) ap['Wochen je Container'] = a.getAttribute('data-bc-weeks') || '1';
      ops.push({ id: a.getAttribute('data-bc-key'), quantity: num(a, 'data-bc-qty', 0), properties: ap });
    });
    changeLines(ops);
  }

  /* ---------- Nach jedem Rendern prüfen ---------- */
  var timer = null, attempts = {};
  function run() {
    var root = inner(), d = drawer();
    if (!root || !d || busy || d.classList.contains('is-empty')) return;
    checkDates(root);
    var ops = planStandzeit(root);
    if (!ops.length) return;
    var sig = JSON.stringify(ops);
    attempts[sig] = (attempts[sig] || 0) + 1;
    if (attempts[sig] > 2) return; /* keine Endlosschleife, falls Shopify eine Änderung ablehnt */
    changeLines(ops);
  }
  function schedule() { clearTimeout(timer); timer = setTimeout(run, 60); }

  /* ---------- Checkout mit geprüfter PLZ ---------- */
  /* Die auf der Startseite geprüfte PLZ wird als Lieferadressen-PLZ vorausgefüllt. Vorher werden Mengen,
     Bestellanweisungen und Zustimmung wie beim normalen Absenden gespeichert. Bei einem Fehler: normaler Weg. */
  var skipPlz = false;
  function savedPlz() {
    try { var v = localStorage.getItem('berk_plz') || ''; return /^\d{5}$/.test(v) ? v : ''; } catch (x) { return ''; }
  }
  function goCheckout(btn, plz) {
    var form = btn.form || document.getElementById('CartDrawer-Form');
    if (!form || !window.fetch || !window.FormData) { skipPlz = true; btn.click(); return; }
    setBusy(true);
    var fd = new FormData(form);
    var nt = document.querySelector('cart-drawer textarea[name="note"]');
    if (nt && !fd.has('note')) fd.append('note', nt.value);
    fetch(url('cart_update_url', '/cart/update'), { method: 'POST', body: fd, headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('update'); return r.json(); })
      .then(function () {
        var root = (window.routes && window.routes.root) || '/';
        if (root.charAt(root.length - 1) !== '/') root += '/';
        window.location.href = root + 'checkout?checkout%5Bshipping_address%5D%5Bzip%5D=' + encodeURIComponent(plz) + '&checkout%5Bshipping_address%5D%5Bcountry%5D=DE';
      })
      .catch(function () { setBusy(false); skipPlz = true; btn.click(); });
  }

  /* ---------- Bedienung ---------- */
  function stop(e) { e.preventDefault(); e.stopImmediatePropagation(); }
  /* nur den Inhaltsbereich scrollen, Kopf und Kassen-Button bleiben stehen */
  function reveal(box, focusEl) {
    var sc = box.closest('.berk-cd__body');
    if (sc) {
      var r = box.getBoundingClientRect(), s = sc.getBoundingClientRect();
      var top = sc.scrollTop + (r.top - s.top) - Math.max(8, (sc.clientHeight - r.height) / 2);
      var target = Math.max(0, Math.min(top, sc.scrollHeight - sc.clientHeight));
      try { sc.scrollTo({ top: target, behavior: 'smooth' }); } catch (x) { sc.scrollTop = target; }
      /* Sicherheitsnetz, falls sanftes Scrollen nicht ausgeführt wird */
      setTimeout(function () { if (Math.abs(sc.scrollTop - target) > 2) sc.scrollTop = target; }, 700);
    }
    if (focusEl) setTimeout(function () { try { focusEl.focus({ preventScroll: true }); } catch (x) { /* */ } }, 380);
  }
  function consentError(cb) {
    var box = cb.closest('.berk-cd-legal');
    if (!box) return;
    box.classList.add('is-error');
    var m = box.querySelector('.berk-cd-legal__err');
    if (m) m.hidden = false;
    reveal(box, cb);
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    var btn = t.closest('#CartDrawer-Checkout');
    if (btn) {
      var root = inner();
      if (!root) return;
      if (busy) { stop(e); return; }
      var fixStz = planStandzeit(root);
      if (fixStz.length) { stop(e); changeLines(fixStz); return; } /* Standzeit erst stimmig machen */
      checkDates(root);
      var bad = root.querySelector('.berk-cd-item.is-date-invalid');
      if (bad) { stop(e); reveal(bad, bad.querySelector('.berk-cd-fix__sel')); return; }
      var cb = root.querySelector('.berk-cd-legal input[type="checkbox"]');
      if (cb && !cb.checked) { stop(e); consentError(cb); return; }
      var plz = skipPlz ? '' : savedPlz();
      skipPlz = false;
      if (plz) { stop(e); goCheckout(btn, plz); }
      return;
    }

    /* Container entfernen: zugehörige Standzeit-Verlängerung im selben Schritt mit entfernen */
    var rm = t.closest('.berk-cd-item .cart-remove-button');
    if (rm) {
      var card = rm.closest('.berk-cd-item');
      var grp = card && card.closest('.berk-cd-group');
      var adds = grp ? grp.querySelectorAll('.berk-cd-addon') : [];
      if (!adds.length) return;
      stop(e);
      if (busy) return;
      var keys = [card.getAttribute('data-bc-key')];
      adds.forEach(function (x) { keys.push(x.getAttribute('data-bc-key')); });
      removeKeys(keys);
      return;
    }

    var wk = t.closest('[data-bc-wk]');
    if (wk) {
      e.preventDefault();
      if (busy) return;
      var a = wk.closest('.berk-cd-addon');
      if (!a) return;
      var w = Math.max(1, num(a, 'data-bc-weeks', 1));
      var covered = Math.max(1, Math.round(num(a, 'data-bc-qty', w) / w));
      var nw = Math.max(0, Math.min(MAX_WEEKS, w + parseInt(wk.getAttribute('data-bc-wk'), 10)));
      if (nw === w) return;
      var p = props(a);
      p['Wochen je Container'] = String(nw);
      changeLines([{ id: a.getAttribute('data-bc-key'), quantity: nw * covered, properties: nw ? p : undefined }]);
    }
  }, true);

  /* Menge unter das Minimum (z. B. 0 eingetippt): zurücksetzen statt Fehlerzustand; Entfernen nur über den Papierkorb */
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.matches || !t.matches('.berk-cd-item .quantity__input')) return;
    var v = parseInt(t.value, 10), min = parseInt(t.getAttribute('min'), 10) || 1;
    if (isNaN(v) || v < min) { e.stopImmediatePropagation(); t.value = t.getAttribute('value'); }
  }, true);

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.matches || !t.matches('.berk-cd-legal input[type="checkbox"]') || !t.checked) return;
    var box = t.closest('.berk-cd-legal');
    if (!box) return;
    box.classList.remove('is-error');
    var m = box.querySelector('.berk-cd-legal__err');
    if (m) m.hidden = true;
  });

  /* Fallback, falls das Formular auf anderem Weg abgeschickt wird: eigene Meldung statt Browser-Blase */
  document.addEventListener('invalid', function (e) {
    var t = e.target;
    if (!t || !t.matches || !t.matches('.berk-cd-legal input[type="checkbox"]')) return;
    e.preventDefault();
    consentError(t);
  }, true);

  /* Bestellanweisungen: beim Aufklappen das Textfeld vollständig in den sichtbaren Bereich holen */
  document.addEventListener('toggle', function (e) {
    var det = e.target;
    if (!det || det.id !== 'Details-CartDrawer' || !det.open) return;
    var sc = det.closest('.berk-cd__body');
    if (!sc) return;
    setTimeout(function () {
      var r = det.getBoundingClientRect(), s = sc.getBoundingClientRect();
      if (r.bottom <= s.bottom - 8) return;
      var top = r.height > s.height - 16 ? sc.scrollTop + (r.top - s.top) - 8 : sc.scrollTop + (r.bottom - s.bottom) + 12;
      top = Math.max(0, Math.min(top, sc.scrollHeight - sc.clientHeight));
      try { sc.scrollTo({ top: top, behavior: 'smooth' }); } catch (x) { sc.scrollTop = top; }
      setTimeout(function () { if (Math.abs(sc.scrollTop - top) > 2) sc.scrollTop = top; }, 700);
    }, 30);
  }, true);

  function start() {
    var d = drawer();
    if (!d) return;
    new MutationObserver(schedule).observe(d, { childList: true, subtree: true });
    schedule();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
